
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1561446571360",
    "class": "icon",
    "viewBox": "0 0 1157 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4429",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "225.9765625",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M0 1024v-60.237913h86.817391V120.475826C86.817391 53.960348 138.640696 0 202.573913 0h405.147826c63.933217 0 115.756522 53.960348 115.756522 120.475826v240.951652h231.513043c63.933217 0 115.756522 53.915826 115.756522 120.475826v481.858783H1157.565217V1024H0zM665.6 120.475826c0-33.302261-25.911652-60.237913-57.878261-60.237913h-405.147826c-31.966609 0-57.878261 26.935652-57.878261 60.237913v843.286261h520.904348V120.475826z m347.269565 361.427478c0-33.302261-25.911652-60.237913-57.878261-60.237913h-231.513043v542.096696h289.391304V481.903304z m-57.878261 150.572522h-173.634782v-60.237913h173.634782v60.237913z m0 180.713739h-173.634782v-60.237913h173.634782v60.237913z m-578.782608-481.903304h-173.634783V271.048348h173.634783v60.237913z m0 180.713739h-173.634783v-60.237913h173.634783V512z m0 180.713739h-173.634783v-60.237913h173.634783v60.237913z m231.513043-361.427478h-173.634782V271.048348h173.634782v60.237913z m0 180.713739h-173.634782v-60.237913h173.634782V512z m0 180.713739h-173.634782v-60.237913h173.634782v60.237913z",
        "fill": "",
        "p-id": "4430"
      }
    }
  ]
})
    }
  